// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = module.exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n.search-row[data-v-73ecd06e] {\n  margin-top: 12px;\n}\n.search-title[data-v-73ecd06e] {\n  width: 150px;\n  font-size: 14px;\n}\n.search-row-item[data-v-73ecd06e] {\n  margin-left: 10px;\n  margin-top: 10px;\n}\n", ""]);
